export var ctaBackgroundGradient = '$-wpkr';